import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMicrochip, faPlay, faPowerOff, faWrench } from "@fortawesome/free-solid-svg-icons";
import { withTranslation } from "react-i18next";

const HardwareStatusCell = props => (
  <b>
    <FontAwesomeIcon icon={faMicrochip}
                     title={props.t("Hardware.Tabs.Index.Modal.Form.IsTPMReady")}
                     className={props.hardware.isTPMReady ? "color-green mr-2" : "color-red mr-2"} />
    <FontAwesomeIcon icon={faWrench}
                     title={props.t("Hardware.Tabs.Index.Modal.Form.IsBootReady")}
                     className={props.hardware.isBootReady ? "color-green mr-2" : "color-red mr-2"} />
    <FontAwesomeIcon icon={faPowerOff}
                     title={props.t("Hardware.Tabs.Index.Modal.Form.IsBootable")}
                     className={props.hardware.isBootable ? "color-green mr-2" : "color-red mr-2"} />
    <FontAwesomeIcon icon={faPlay}
                     title={props.t("Hardware.Tabs.Index.Modal.Form.IsRunningStable")}
                     className={props.hardware.isRunningStable ? "color-green" : "color-red"} />
  </b>
);

export default withTranslation()(HardwareStatusCell);
